<template>
    <div class="learning">
        <div class="learnTop"></div>
        <ActivityList :type="2"></ActivityList>
    </div>
</template>
<script>
import ActivityList from '../../home/components/activityList.vue';

export default {
    name: 'Learning',
    components: {
        ActivityList
    },
    data() {
        return {
            type: 2, // 1是首页 2 是学习页面列表

        };
    },
    mounted() {

    },
    created() {
    },
    methods: {},
};
</script>

<style scoped lang="less">
.learning{
    min-height: 100vh;
    padding-bottom: 100px;
    background: #ffffff;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    .learnTop{
        margin-top: 32px;
    }
}
</style>
